import { useMemo } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { useTranslation } from "react-i18next";

// Layout
import Navbar from "components/Navbars";

// FAQ wrapper (fetches from /web2/faq/ and renders presentational FAQ)
import FaqFromApi from "components/FaqFromApi";

// Images (use any existing hero background image in your project)
import bgImage from "assets/images/bg-about-us.jpg";

function FAQs() {
  const { t, i18n } = useTranslation();

  const faqLang = useMemo(
    () => (i18n.language && i18n.language.toLowerCase().startsWith("zh") ? "zh" : "en"),
    [i18n.language]
  );

  return (
    <>
      <Navbar
        transparent
        light
        showMenu={false}
        action={{
          type: "internal",
          route: "/userinfo/",
          label: t("common.backToHome"),
          color: "info",
        }}
      />

      {/* Simple hero: background only */}
      <MKBox
        minHeight="30vh"
        width="100%"
        sx={({ functions: { linearGradient, rgba }, palette }) => ({
          backgroundImage: `${linearGradient(
            rgba(palette.gradients.dark.main, 0.6),
            rgba(palette.gradients.dark.state, 0.6)
          )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        })}
      />

      <Card
        sx={{
          // Make padding/margins shrink smoothly on narrower screens
          p: { xs: 1, sm: 1.5, md: 2 },
          mx: { xs: 1, sm: 1.5, md: 2, lg: 3 },
          mt: { xs: -6, md: -8 },
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container maxWidth={false} disableGutters>
          <MKBox
            sx={{
              width: "100%",
              maxWidth: 1200,
              mx: "auto",
              px: { xs: 1, sm: 1.25, md: 1.5 },
            }}
          >
            <MKBox pt={2} pb={1} textAlign="center">
              <MKTypography variant="h3" fontWeight="bold">
                {t("faq.title")}
              </MKTypography>
            </MKBox>

            <MKBox mt={2}>
              <FaqFromApi tags={["general"]} lang={faqLang} defaultExpanded={false} />
            </MKBox>
          </MKBox>
        </Container>
      </Card>
    </>
  );
}

export default FAQs;
